import React, { Component } from 'react';
import { connect } from 'react-redux';
import styled from 'styled-components';
import { FaChevronRight } from 'react-icons/fa';

import LoadingComponent from '../../components/common/LoadingComponent';
import { FlyInTransition } from '../../components/transitions/transitions';
import { getAllPodcasts } from '../../services/health-content';
import Modal from '../common/Modal';
import Player from './PodcastPlayer';
import Header from '../../components/common/Header';

const OuterContainer = styled.div`
  display: flex;
  flex: 1;
  flex-direction: column;
  align-items: stretch;
  overflow-y: auto;
  background: white;
`;

const BodyContainer = styled.div`
  flex: 1;
  flex-shrink: 0;
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
  padding: 16px 0;
`;

const SectionHeader = styled.div`
  font-weight: 600;
  font-size: 14px;
  line-height: 15px;
  display: flex;
  align-items: center;
  letter-spacing: 0.1px;
  color: #413958;
  padding-left: 16px;
`;

const HoverContent = styled.div`
  background: linear-gradient(
    0deg,
    rgba(0, 0, 0, 0.9) 0%,
    rgba(0, 0, 0, 0) 100%
  );
  position: absolute;
  padding: 16px 13px;
  bottom: 0px;
  left: 0px;
  border-radius: 0px 0px 8px 8px;
  width: 175px;
  color: #ffffff;
`;

const CardTitle = styled.div`
  font-weight: 700;
  font-size: 14px;
  line-height: 17px;
  display: flex;
  align-items: center;
  color: #ffffff;
`;

const CardDescription = styled.div`
  font-weight: 600;
  font-size: 10px;
  line-height: 12px;
  display: flex;
  align-items: center;
  color: #e6e6e6;
  margin-top: 2px;
`;

const ModalContainer = styled.div`
  display: flex;
  height: 100%;
  width: 100%;
  flex-direction: column;
  align-items: center;
  justify-content: flex-end;
  background: rgba(0, 0, 0, 0.5);
  overflow: hidden;
`;

const AngleRight = styled(FaChevronRight)`
  color: #413958;
  width: 8px;
  height: 8px;
`;

class PodcastsHome extends Component {
  constructor(props) {
    super(props);

    this.state = {
      loading: true,
      allPodcasts: [],
      showPlayerModal: false,
      selectedAlbum: null,
    };
  }

  componentDidMount() {
    this.getAllPodcasts();
    if (
      typeof window.Android !== 'undefined' &&
      window.Android &&
      window.Android.podcastPage
    ) {
      return window.Android.podcastPage();
    }
    if (window.ReactNativeWebView) {
      window.ReactNativeWebView.postMessage(
        JSON.stringify({
          method: 'podcastPage',
        })
      );
    }
  }

  getAllPodcasts() {
    getAllPodcasts(this.props.authToken)
      .then((res) => {
        console.log(res, 'podcasts_data');
        this.setState({ allPodcasts: res.cards });
      })
      .catch((err) => {
        console.log(err);
      })
      .finally(() => {
        this.setState({ loading: false });
      });
  }

  onAlbumClick = (album) => {
    if (album.showAudioPlayer) {
      this.setState({ selectedAlbum: album, showPlayerModal: true });
    } else {
      //it is a album container
      console.log(album, 'here it is');
      this.props.history.push('/health-content/sub-podcasts', {
        albumId: album.albumId,
      });
    }
  };

  hideModal = () => {
    console.log('clicked');
    this.setState({ showPlayerModal: false });
  };

  closeView = () => {
    if (this.props.magicBasedLogin) {
      if (typeof window.Android !== 'undefined') {
        window.Android.closeView();
        window.Android.closeView(true);
      } else if (window.ReactNativeWebView) {
        window.ReactNativeWebView.postMessage(
          JSON.stringify({
            method: 'closeView',
          })
        );
      } else if (window.webkit && window.webkit.messageHandlers.visitIosView) {
        window.webkit.messageHandlers.visitIosView.postMessage(
          JSON.stringify({
            method: 'closeView',
          })
        );
      } else {
        this.props.history.goBack();
      }
    } else {
      this.props.history.goBack();
    }
  };

  render() {
    const { allPodcasts, showPlayerModal, selectedAlbum, loading } = this.state;

    const renderPodcastCards = (cards) => {
      return cards.map((card) => {
        if (card.type === 'activeProgram') {
          const albumInfo = card.albums[0];
          return (
            <div className="px-16px">
              {' '}
              <SectionHeader>{card.title}</SectionHeader>
              <div
                className="border border-txtsecondary-shades7 rounded-12 mt-12px p-4"
                onClick={() => {
                  // this.props.history.push('/health-content/sub-podcasts', {
                  //   albumId: albumInfo.albumId,
                  //   albumsSessionsId: albumInfo.albumsSessionsId,
                  //   currentDuration: albumInfo.duration,
                  // });
                  this.setState({
                    selectedAlbum: albumInfo,
                    showPlayerModal: true,
                  });
                }}
              >
                <div className="flex gap-2 text-body-l font-semibold text-txtlight mb-12px">
                  <img
                    src={albumInfo.imageUrl}
                    className="w-12 h-12 rounded-8"
                  />
                  {albumInfo.albumTitle}
                </div>
                <div className="bg-txtsecondary-shades4 text-txtlight text-body-s font-semibold p-2 rounded-12 text-center">
                  Continue
                </div>
              </div>
            </div>
          );
        }
        const albums = card.albums;
        return (
          <div style={{ marginTop: '25px' }}>
            <div className="flex justify-between">
              <SectionHeader>{card.title}</SectionHeader>
              {card.seeAll && (
                <div
                  className="flex items-center pr-12px cursor-pointer"
                  onClick={() =>
                    this.props.history.push(
                      `/health-content/podcasts-home/${card.type}`,
                      {
                        card,
                      }
                    )
                  }
                >
                  <p className="text-body-l font-semibold text-purpleText">
                    See all
                  </p>
                  <div className="p-5 bg-primary-shades1 rounded-full ml-8px">
                    <AngleRight />
                  </div>
                </div>
              )}
            </div>
            {albums && albums.length > 0 && (
              <div className="flex overflow-x-auto justify-start mt-16px px-16px">
                {albums.map((album) => {
                  return (
                    <button
                      style={{ position: 'relative' }}
                      onClick={() => this.onAlbumClick(album)}
                      className="text-left"
                    >
                      <img
                        src={album.imageUrl}
                        style={{
                          width: '175px',
                          height: '175px',
                          marginRight: '200px',
                          borderRadius: '8px',
                        }}
                      />
                      <HoverContent>
                        <CardTitle>{album.albumTitle}</CardTitle>
                        <CardDescription>{album.coachName}</CardDescription>
                      </HoverContent>
                    </button>
                  );
                })}
              </div>
            )}
          </div>
        );
      });
    };

    return (
      <OuterContainer>
        <Header title="Meditation" onTap={() => this.closeView()} />
        <BodyContainer>
          {loading ? (
            <LoadingComponent />
          ) : (
            <div>{renderPodcastCards(allPodcasts)}</div>
          )}
          {/* <div style={{ marginTop: '25px' }}>
            {renderPodcastCards(personalGrowthAlbums)}
          </div>
          <div style={{ marginTop: '25px' }}>
            {renderPodcastCards(workAlbums)}
          </div> */}
        </BodyContainer>
        {showPlayerModal && (
          <Modal>
            <ModalContainer onClick={this.hideModal}>
              <FlyInTransition
                in={showPlayerModal}
                mountOnEnter
                unmountOnExit
                appear
              >
                <Player
                  album={selectedAlbum}
                  authToken={this.props.authToken}
                  hideModal={this.hideModal}
                />
              </FlyInTransition>
            </ModalContainer>
          </Modal>
        )}
      </OuterContainer>
    );
  }
}

const mapStateToProps = (state) => ({
  authToken: state.user.authToken,
  magicBasedLogin: state.app.magicBasedLogin,
});

export default connect(mapStateToProps)(PodcastsHome);
